export default __webpack_public_path__ + "static/media/dogcuddle.ee251a04.jpg";